import { assertNever } from "@msys/common";
import type { question } from "@msys/question-isomorphic";
import { WizardQuestions_Question_WizardMultiplePropertiesQuestion_Fragment } from "../../documents/WizardQuestions.generated.js";

type Question =
  WizardQuestions_Question_WizardMultiplePropertiesQuestion_Fragment;
type Input = Question["askIfContext"]["inputs"][number];

/** The query's ask-if fields in the shape `wizard.askIf` evaluates. */
export function askIfFromQuestion(q: Question): question.QuestionAskIf {
  return {
    visiblePropKeys: q.props.filter(p => p.visible).map(p => p.prop.key),
    context: {
      expressions: q.askIfContext.expressions.map(expression => ({
        target: {
          kind:
            expression.target === "ASK_IF"
              ? "ITEM_PROPERTY_ASK_IF"
              : "ITEM_PROPERTY_VALUE",
          itemId: expression.itemId,
          propertyKey: expression.propertyKey,
        },
        resultDataType: expression.resultDataType,
        value: expression.source,
      })),
      inputs: q.askIfContext.inputs.map(input => ({
        scope: input.scope === "ITEM_PROPERTY" ? "item" : "product",
        itemId: input.itemId,
        key: input.key,
        value: inputValue(input),
      })),
    },
  };
}

function inputValue(
  input: Input
): question.AskIfContext["inputs"][number]["value"] {
  switch (input.kind) {
    case "missing":
      return { kind: "missing" };
    case "text":
      return { kind: "text", value: input.valueText ?? null };
    case "number":
      return { kind: "number", value: input.valueNumber ?? null };
    case "boolean":
      return { kind: "boolean", value: input.valueBool ?? null };
    case "text_array":
      return { kind: "text_array", value: input.valueTextArray ?? null };
    case "number_array":
      return { kind: "number_array", value: input.valueNumberArray ?? null };
    default:
      assertNever(input.kind);
  }
}
